import { Box, styled, Typography } from '@mui/material';
import { fontWeight } from '../../../../lib/theme/typography';
import { pxToRem } from '../../../../utils/getFontValue';
import { UIColors } from '../../../../constants/UIConstants';

export const StyledUploadComponentContainer = styled(Box)`
  height: auto;
  min-height: ${pxToRem(432)};
`;

export const FileUploadText = styled(Box)`
  padding-bottom: ${pxToRem(18)};
`;

export const TopLineText = styled(Typography)`
  font-weight: ${fontWeight.regular};
  font-size: ${pxToRem(16)};
  line-height: ${pxToRem(28)};
  color: ${UIColors.textColors.black};
`;

export const RecommendedText = styled(Typography)`
  font-style: italic;
  margin-top: ${pxToRem(8)};
  margin-bottom: ${pxToRem(8)};
`;

export const EmailHintBanner = styled(Typography)`
  font-size: ${pxToRem(14)};
  line-height: ${pxToRem(20)};
  color: #1e3a8a;
  background-color: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: ${pxToRem(8)};
  padding: ${pxToRem(12)};
  margin-bottom: ${pxToRem(16)};
`;
